export const MODAL_CONFIGS = {
    content: {
        width: "400px",
        padding: 0,
    },
};
